import { ArticleType } from '@/services/types/article.type';

// 매핑 객체
export const ArticleTypeKorean: Record<ArticleType, string> = {
  [ArticleType.FAQ]: '자주 묻는 질문',
  [ArticleType.NOTICE]: '공지사항',
  [ArticleType.EVENT]: '이벤트',
  [ArticleType.BLOG]: '블로그',
};
export function getArticleTypeKorean(type: ArticleType): string {
  return ArticleTypeKorean[type];
}
